type SoftDeletable = {
  deletedAt: Date | null;
};

export default function isDeleted<T>(entity: T & SoftDeletable): boolean {
  return entity.deletedAt !== null;
}
